import { defineStore } from 'pinia';
import { PINIA_PERSIST_OPTIONS } from '@/helpers';
import logger from '@/helpers/logger';

export const useUtilstStore = defineStore({
	id: 'utils',
	state: () => ({
		existingBusiness: null,
		newBusinessObject: null,
		pendingSetupPayload: null,
		numberPurchaseMode: false,
		welcomeGreetingsRecentlySet: false,
		IVRRecentlySet: false,
		setUpProgressTracker: {
			setUpMode: 'default',
			currentStep: 1,
			isActiveStep: false,
			inviteMode: null,
			completedSteps: [],
			isProcessComplete: true,
			isProcessStarted: false
		},
		setUpSteps: [
			{
				name: 'Invite Your Team Members to PressOne',
				completed: false
			},
			{
				name: 'Configure Incoming Call Flow',
				completed: false
			},
			{
				name: 'Setup Professional Greetings',
				completed: false
			},
			{
				name: 'Publish Your PressOne Number',
				completed: false
			}
		],
		onboardingStartModal: false,
		walkThroughGuide: {
			start: false,
			done: false,
			currentStep: null
		},
		subscriptionPlans: null,
		isRecommendedPlanView: false,
		isRecommendedPlanMode: false,
		nonRecommendedPlanId: null,
		signUpMode: false,
		signUpFormData: {
			first_name: '',
			last_name: '',
			personal_email: '',
			mobile: '',
			id: null
		},
		signUpSource: '',
		downloadMobileAppMode: false,
		showTestCall: false,
		showTestCallGoodModal: false,
		showTestCallBadModal: false,
		showAirtimeRefundedModal: false,
		// Checks if user has completed or ignored the testcall in complete-setup view
		hasTestedCall: false,
		showTestProGreetings: false,
		hasListenedToGreeting: false, // Checks if user has listened to the testgreeting
		businessFormData: null,
		isDoneOnboarding: true, // Checks if user has completed all the setup flow
		selectProblemWithProGreeting: false, // Shows modal if there was an issue with the greeting
		resetGreetingVoice: false, // Shows screen for user complaint to change voice
		resetGreetingText: false, // Shows screen for user complaint to edit greeting script
		showResetStartModal: false,
		showDownloadBanner: true,
		showAddAppToHomeScreenModal: false,
		showAddAppToHomeScreenlater: false,
		appAddedToHomeScreen: false,
		showRenewalBanner: false,
		transactionRef: null,
		inactiveBusinessId: null,
		hasRenewedExpiredSubscription: true,
		isNumberProvisioning: false,
		isNumberActivating: false,
		pendingMember: null,
		hasUpgradedTeam: false,
		isCallFromTest: false,
		showBrassPopUpModal: null,
		isNewBusinessNumberSetup: false,
		isTicketRaised: false,
		ticketSupportPage: null,
		showDownloadModalForMobile: false,
		finishedProGreetingsForMobile: false
	}),
	getters: {
		isSetUpProcessComplete: (state) => !!state.setUpProgressTracker.isProcessComplete
	},
	actions: {
		setExistingBusinessPayload(payload) {
			this.existingBusiness = payload;
		},
		checkIfDesktop() {
			let isDesktop = false;
			if (
				!navigator.userAgent.match(
					/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi|Tablet|iPad/i
				)
			) {
				isDesktop = true;
			}
			return isDesktop;
		},
		setShowAddAppToHomeScreenModal(payload) {
			this.showAddAppToHomeScreenModal = payload;
		},
		setShowAddAppToHomeScreenlater(payload) {
			this.showAddAppToHomeScreenlater = payload;
		},
		setAppAddedToHomeScreen(payload) {
			this.appAddedToHomeScreen = payload;
		},
		setSubscriptionPlans(payload) {
			const idToModelMap = [
				'Basic plan allows you to make, receive and record calls. You can add a maximum of 3 users in this plan.',
				'With PressOne Pro, you can make 3 calls at the same time. You can add up to three users, with an extra user incurring a charge of 1000.',
				'With PressOne Platinum, you can make up to 5 calls at the same time. Get access to local and international phone number with this plan.'
			];
			try {
				payload.sort((a, b) => a.id - b.id);
				payload.forEach((plan, index) => {
					const model = idToModelMap[index];
					if (model) {
						plan.description = model;
					}
				});
				this.subscriptionPlans = payload;
			} catch (error) {
				logger.error(error, 'error setting subscription plans');
			}
		},

		setNewBusinessPayload(payload) {
			this.newBusinessObject = payload;
		},

		setSetUpPayload(payload) {
			this.pendingSetupPayload = payload;
		},

		clearExistingBusinessPayload() {
			// this.existingBusinessId = null;
			this.existingBusiness = null;
		},

		clearNewBusinessPayload() {
			this.newBusinessObject = null;
		},
		stopWalkThroughGuide() {
			this.walkThroughGuide.done = false;
			this.walkThroughGuide.start = false;
			this.walkThroughGuide.currentStep = null;
			this.downloadMobileAppMode = true;
			if (this.checkIfDesktop()) {
				setTimeout(() => {
					this.setShowAddAppToHomeScreenModal(true);
				}, 2000);
			}
		}
	},
	persist: PINIA_PERSIST_OPTIONS
});
